module.exports = __webpack_public_path__ + "img/start_6.d8069545.svg";